<template>
    <div class="subscription-document-list mt-4">
        <div class="row">
            <div class="col-12" v-if="title">
                <p><b>{{ title }}</b></p>
            </div>
            <div class="col-12 mt-3">
                <div class="table-responsive">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col"><span class="table-heading">{{ $t('cdb.documents.header.date')}}</span></th>
                                <th scope="col"><span class="table-heading">{{ $t('cdb.documents.header.note')}}</span></th>
                                <th scope="col"><span class="table-heading">{{ $t('cdb.documents.header.file')}}</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(document, index) in documents"
                                :key="index"
                            >
                                <td>{{ getDate(document.date) }}</td>
                                <td>{{ document.customer_notice }}</td>
                                <td><a @click="handleDownloadClick($event, document.link)" href="#">pdf</a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from "../../event-bus"
export default {
    name: 'SubscriptionDocumentList',
    props: {
        title: {
            type: String,
            required: false
        },
        documents: {
            type: Array,
            required: true
        }
    },
    data: {
        isLoading: true,

    },
    methods: {
        getDate(date){
            return this.$d(new Date(date), 'short')
        },
        handleDownloadClick(event, link) {
            event.preventDefault();
            EventBus.$emit('download-clicked', event, link);
        },
    }
}
</script>
